import React from 'react';
interface PosterFallbackProps {
  variant?: 'card' | 'hero';
}

/** Elegant reserve frame used when a production has no real image yet. */
export function PosterFallback({
  variant = 'card'
}: PosterFallbackProps) {
  const isHero = variant === 'hero';
  return <div aria-hidden="true" className={`relative flex h-full w-full overflow-hidden bg-coal ${isHero ? 'items-center justify-end pr-[6vw]' : 'items-center justify-center'}`} data-id="element-217" data-mp="2aoh75jaipkjy">
      <div className={`absolute border border-graphite ${isHero ? 'inset-6 md:inset-10' : 'inset-2.5 rounded-sm'}`} data-id="element-218" data-mp="25r7c9o4d0goq" />
      {isHero && <>
          <div className="absolute left-6 right-6 top-1/3 h-px bg-graphite/70 md:left-10 md:right-10" data-id="element-219" data-mp="1rsr2fob7aa2d" />
          <div className="absolute bottom-6 top-6 right-1/3 w-px bg-graphite/70 md:bottom-10 md:top-10" data-id="element-220" data-mp="1vtjeepbgit2c" />
        </>}
      <span className="text-outline relative select-none font-display font-black leading-none" style={{
      fontSize: isHero ? 'min(70vh, 48vw)' : 'clamp(4rem, 9vw, 7rem)'
    }} data-id="element-221" data-mp="3m3cjuzpltbxv">
        N
      </span>
    </div>;
}